import {
  Sheet,
  SheetBody,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { RoleMappingsTab } from './RoleMappingsTab';

interface Props {
  open: boolean;
  schoolId: number;
  schoolName?: string;
  onClose: () => void;
}

/**
 * Drawer latéral droit qui affiche le mapping des rôles V1 → V2 pour une école.
 *
 * Déclenché depuis le header du groupe de lots « Utilisateurs » dans la
 * `LotsTable`. Le mapping global reste géré dans `/migration-v1-v2/config`.
 */
export function RoleMappingsDialog({ open, schoolId, schoolName, onClose }: Props) {
  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent
        side="right"
        className="sm:w-[min(95vw,1100px)] sm:max-w-[1100px]"
      >
        <SheetHeader>
          <SheetTitle>
            Mappings rôles V1 → V2{schoolName ? ` — ${schoolName}` : ''}
          </SheetTitle>
          <SheetDescription>
            Override par école sur le mapping <code>usertypeID</code> V1 →{' '}
            <code>tenant role</code> V2. Le mapping global (config{' '}
            <code>/migration-v1-v2/config</code>) reste appliqué en fallback pour chaque
            rôle non-overrideé.
          </SheetDescription>
        </SheetHeader>

        <SheetBody>
          <RoleMappingsTab schoolId={schoolId} />
        </SheetBody>
      </SheetContent>
    </Sheet>
  );
}
